"use client";
import React from "react";
import ProductCard from "../Cards/ProductCard";

import wwd1 from "../../../public/assets/ash-handling-equip.webp";
import wwd2 from "../../../public/assets/slurry-pumps-spares.webp"; 

const products = [
  {
    id: 1,
    href: "#",
    title: "Ash Handling Equipments",
    category: "Ash Handling",
    image: wwd1,
    description:
      "Melco have own manufacturing unit to manufacture various equipments of ash handling system. Following are some of the equipments manufactured at our factory.",
    list: [],
  },
  {
    id: 2,
    href: "#",
    title: "SLURRY PUMP REPLACEMENT PARTS",
    category: "Ash Handling",
    image: wwd2,
    description:
      "Melco manufacture and supply Various make & Model slurry pump components with interchangeability to the existing pumps.",
    list: [
      "Feed Gate",
      "Clinker Grinders",
      "Hydro Jet Pumps",
      "Knife Gate Valves",
      "Feed sump",
      "Scrapper Chain Conveyors",
    ],
  },
];

const ProductSec = () => {
  return (
    <section className="relative w-full pt-16 sm:pt-20 pb-28 sm:pb-32 px-4 md:px-8 bg-gray-100 overflow-hidden border-none outline-none">
      {/* Top Center Angular Notch / Cutout */}
      {/* <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-48 sm:w-64 h-8 bg-[#fff] pointer-events-none z-30"
        style={{ clipPath: "polygon(0 0, 100% 0, 80% 100%, 20% 100%)" }}
      /> */}
     
      {/* Main Container */}
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <span className="text-[#ffa20d] font-bold text-sm tracking-wider uppercase block mb-1">
            Products
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight whitespace-pre-line">
            Products & Parts 
          </h2>
        </div>

        {/* Responsive Grid: Mobile & Tablet par 1 Column, Large Desktop (lg) par 2 Columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {products.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>
      </div>

      {/* Bottom Notch / Cut Shape */}
      <div
        className="absolute -bottom-px left-1/2 -translate-x-1/2 w-48 sm:w-64 h-8 bg-[#282930] pointer-events-none z-30"
        style={{ clipPath: "polygon(20% 0, 80% 0, 100% 100%, 0 100%)" }}
      />
    </section>
  );
};

export default ProductSec;